import gql from 'graphql-tag';

export default gql`
  fragment preleadKeyPersonFragment on PreleadKeyPerson {
    id
    department
    firstName
    lastName
    position
    updatedAt
    facebookUrl
    xUrl
    linkedinUrl
    wantedlyUrl
    eightUrl
    telephoneNumber
    note
  }
`;
